<!-- 新闻，文章类详情页面 -->
<template>
  <div class="">
    <PCNavbar />
    <div class="main-wrap">
      <div class="block-wrap">
        <div class="article">
          <div class="article-title">{{ detail.title }}</div>
          <div class="article-info">{{ detail.time }}</div>
          <div class="article-content" v-html="detail.content"></div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import CifuAPI from "@/utils/api";
import { formatDate } from "@/utils/tools";
import PCNavbar from "@/components/navbar/index";
import Footer from "@/components/footer/index";

export default {
  name: "PartyBuilding",
  components: { PCNavbar, Footer },
  data() {
    return {
      detail: {},
    };
  },
  created() {
    this.getDetail();
  },
  methods: {
    async getDetail() {
      const res = await CifuAPI.getArticleDetail({ id: this.$route.query.id });
      res.data.time = formatDate(res.data.show_time, "YYYY.MM.DD");
      this.detail = res.data;
    },
  },
};
</script>

<style lang="scss" scoped>
.pageView{
  width: 100%;
  min-width: 1400px;
}
.article {
  padding-top: 50px;
  margin-top: 50px;
  @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
    padding-top: 20px;
  }
  &-title {
    margin-bottom: 16px;
    font-weight: bold;
    font-size: 32px;
    color: #663301;
    @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
      font-size: 16px;
    }
  }
  &-info {
    font-size: 24px;
    color: #828282;
    line-height: 26px;
    @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
      font-size: 12px;
    }
  }
  &-content {
    padding-top: 32px;
    font-size: 20px;
    color: #4f4f4f;
    line-height: 32px;
    @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
      padding-top: 20px;
      font-size: 14px;
      ::v-deep img {
        width: 100% !important;
      }
    }
  }
}
</style>
